<template>
  <div class="container-fluid mt-2">
    <div class="row">
      <div class="col-md">
        <h3>Laufende Aufgaben</h3>
        <ul class="list-group">
          <li class="list-group-item" v-for="t in tasklist" :key="t.name">
            <div class="row">
              <router-link :to="'/tasklist/' + encodeURIComponent(t.id)"><h5>{{ t.name }}</h5></router-link>
            </div>
            <div class="row">
              <small class="form-text text-muted">{{ t.created }}</small>
            </div>
          </li>
        </ul>
      </div>
      <div class="col-md">
        <h3>Prozess starten</h3>
        <div class="row">
          <table class="table table-striped border">
            <tbody>
              <tr v-for="p in startlist" :key="p.name">
                <td>
                  <label>{{ p.name }}</label>
                </td>
                <td>
                  <button @click="startProcess(p)" class="btn btn-primary"><font-awesome-icon icon="play"/></button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <hr/>
        <h3>Benutzer Aktion</h3>
        <div class="row">
          <table class="table table-striped border">
            <tbody>
              <tr v-for="p in estartlist" :key="p.id">
                <td>
                  <label>{{ p.name }}</label>
                </td>
                <td>
                  <button @click="startTrigger(p)" class="btn btn-primary"><font-awesome-icon icon="play"/></button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import services from '@/modules/services.js'
import bflows from '@/modules/bflows.js'

export default {
  name: 'TaskList',
  data() {
    return {
      tasklist: [],
      startlist: [],
      estartlist: [],
    }
  },
  created: function() {
    var self = this;
    services.startlist(this,'',function(data) {
      self.startlist = data;
    })
    bflows.listusertrigger(this,'',function(data) {
      self.estartlist = data;
    })
    this.fetchTaskList();
  },
  methods: {
    startProcess: function(proc) {
      console.log(proc.procid);
      var self = this;
      if (confirm('Möchten Sie den Prozess: ' + proc.name + ' starten?')) {
        services.starttaskproc(this,proc.procid,function() {
          self.$bvToast.toast('Prozess gestartet',{title: 'Prozess starten',variant: 'success'});
          setTimeout(self.fetchTaskList.bind(this),1000);
        });
      }
    },
    startTrigger(e) {
      console.log(e);
      var self = this;
      bflows.usertrigger(this,e.id,{},function(data) {
        console.log('done trigger');
        self.$bvToast.toast('Aufgabe gestartet',{title: 'Benutzeraufgabe starten',variant: 'success'});
        console.log(data);
      })
    },
    fetchTaskList() {
      var self = this;
      services.tasklist(this,false,function(data) {
        self.tasklist = data;
      })
    }
  }
}
</script>
